module.exports = __webpack_public_path__ + "img/language-en.2f438f1b.png";